
import { BasicController, EnvGlobalsHandler } from "@goodgamestudios/core";
import { FlashUIComponent } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";

import { TextField } from "@goodgamestudios/createjs-utilities";

import { AvatarCreationEvent } from "../../event/AvatarCreationEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2LanguageFontManager } from '../Poker2LanguageFontManager';

import { Linear, TweenLite } from "gsap";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2NameSelection extends FlashUIComponent {
    public static NAME: string = "Poker2NameSelection";

    constructor(disp: Container, target: MovieClip) {
        super(disp);
        var targetBounds: Rectangle = target.getBounds(null);
        disp.y = targetBounds.bottom;
    }

    protected init(): void {
        super.init();
        this.avatarNameSelction.txt_title.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
    }

    public showNames(paramObject: any): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.avatarNameSelction.txt_title, Poker2Model.languageData.getTextById("generic_register_namealreadyused"));

        while (this.avatarNameSelction.mc_holder.numChildren > 0)
            this.avatarNameSelction.mc_holder.removeChildAt(0);

        if (paramObject.NS) {
            for (let entryList of paramObject.NS) {
                var name: any = entryList;
                if (name === undefined) continue;

                var textField: Library.PokerInterface.NameSelctionText = new Library.PokerInterface.NameSelctionText();
                textField.txt_msg.text = name;
                textField.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
                textField.name = name;
                textField.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onSelectName));
                textField.y = this.avatarNameSelction.mc_holder.numChildren * (textField.height + 5);
                this.avatarNameSelction.mc_holder.addChild(textField);
            }
            this.show();
        }
    }

    protected updateTextField(textField: TextField): void {
        Poker2LanguageFontManager.getInstance().changeFontByLanguage(textField);
    }

    public hide(): void {

        if (this.disp)
            TweenLite.fromTo(this.disp, .1, { scaleX: 1, scaleY: 1 }, { scaleX: 0, scaleY: 0, ease: Linear.easeIn, onComplete: super.hide.bind(this)});

    }

    public show(): void {
        if (this.disp)
            TweenLite.fromTo(this.disp, .1, { scaleX: 0, scaleY: 0 }, { scaleX: 1, scaleY: 1, ease: Linear.easeIn });

        super.show();
    }

    public destroy(): void {
        while (this.avatarNameSelction.mc_holder.numChildren > 0) {
            var child: Library.PokerInterface.NameSelctionText = this.avatarNameSelction.mc_holder.getChildAt(0) as Library.PokerInterface.NameSelctionText;

            if (child instanceof Library.PokerInterface.NameSelctionText) {
                child.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onSelectName));
                this.avatarNameSelction.mc_holder.removeChild(child);
            }
        }
        super.destroy();
    }

    private onSelectName(event: MouseEvent): void {
        var name: string = String(event.currentTarget.name);

        if (name == null || name.length == 0)
            return;
        this.disp.dispatchEvent(new AvatarCreationEvent("avatarnameselected", [name]));
        this.hide();
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    private get avatarNameSelction(): Library.PokerInterface.AvatarNameSelection {
        return this.disp as Library.PokerInterface.AvatarNameSelection;
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

import { castAs } from "@goodgamestudios/createjs-utilities";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
